// extracted by mini-css-extract-plugin
module.exports = {"productImageContainer":"CartLineItemImage_productImageContainer__ck9vJ","mini":"CartLineItemImage_mini__8FLzL"};